<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import { Col, Row } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import data from "../../../Data/ComponentData/WidgetData/Genral/Weather.json";
  import * as SvgIcon from "../../../Data/SvgIcon/SvgIcon";
  import { India, Surat } from "../../../utils/Constant/Constant";
</script>

<Col xl="3" sm="6" class="xl-50 box-col-6">
  <Card cardProps="weather-widget-two">
    <div slot="contentbody">
        {#each data.weather as Item}
          <div class="media">
            {@html SvgIcon[Item.svg]}
            <div class="media-body align-self-center text-white">
              <h4 class="m-0 f-w-600 num">{Item.tempature}</h4>
              <p class="m-0 f-14">{Item.city}</p>
            </div>
          </div>
        {/each}
        <div class="top-bg-whether">
          {@html SvgIcon["weather4"]}
        </div>
        <div class="bottom-whetherinfo">
          <Row>
            <Col xs="6">
              <FeatherIcon icon="cloud-drizzle" />
            </Col>
            <Col xs="6">
              <div class="whether-content">
                <span>{India}, {Surat}</span>
                <h4 class="num mb-0">36°F</h4>
              </div>
            </Col>
          </Row>
        </div>
    </div>
  </Card>
</Col>
